import React from "react";
import { Props } from "./type";

function EditIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 17.498 17.498">
      <path d="M13.124,0,10.936,2.187l4.375,4.375L17.5,4.375ZM8.749,4.375,0,13.124V17.5H4.375l8.749-8.749Z" />
    </svg>
  );
}

export { EditIcon };
